var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomatedReminders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#001C80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1117 57.7046C36.1258 58.9601 37.5911 59.7688 39.1939 59.9576C40.7968 60.1464 42.4098 59.7002 43.6878 58.7146C44.0798 58.4226 44.4319 58.0826 44.7359 57.7046M23.0015 43.5744V43.1364C23.0672 41.8379 23.4833 40.5814 24.2055 39.5003C25.4068 38.203 26.2324 36.6031 26.5936 34.8722C26.5936 33.5402 26.5936 32.1882 26.7096 30.8542C27.3096 24.4361 33.6557 20 39.9218 20H40.0778C46.3439 20 52.69 24.4361 53.312 30.8542C53.428 32.1882 53.312 33.5402 53.408 34.8722C53.7736 36.6064 54.5976 38.2108 55.794 39.5183C56.5241 40.5943 56.9401 41.8464 56.9981 43.1384V43.5564C57.0421 45.2964 56.4421 46.9944 55.31 48.3365C53.802 49.9099 51.7748 50.8833 49.6039 51.0765C43.2138 51.7625 36.7657 51.7625 30.3756 51.0765C28.2072 50.8747 26.1828 49.9026 24.6695 48.3365C23.5584 47.0024 22.9661 45.3122 23.0015 43.5764V43.5744Z",
    stroke: "#001C80",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedReminders);
export default __webpack_public_path__ + "static/media/AutomatedReminders.7b58391e1b622c78e45f9d1cad473473.svg";
export { ForwardRef as ReactComponent };